<template>
  <main class="pt-16">
    <!-- Section bannière avec image -->
    <div class="w-full flex items-center justify-center" style="background-color: #F4F5F5;">
      <div class="relative w-full" style="max-width: 1240px;">
        <!-- Image de fond -->
        <img
          v-if="bannerImage"
          :src="bannerImage"
          alt="Bannière REDMI Note 15 Series"
          class="h-auto object-contain w-full"
        />

        <!-- Overlay textes et logos -->
        <div class="absolute inset-0">
          <!-- Logo Xiaomi (top right) -->
          <div class="absolute top-2 right-2 sm:top-3 sm:right-3 md:top-4 md:right-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 sm:h-8 md:h-10 lg:h-12 w-auto" viewBox="-200.008 -199.727 512 512">
              <g>
                <path fill="#FF6900" d="M258.626-146.231c-48.304-48.118-117.759-53.496-202.634-53.496c-84.982,0-154.542,5.44-202.826,53.688c-48.277,48.228-53.174,117.676-53.174,202.561c0,84.899,4.897,154.368,53.194,202.613c48.281,48.255,117.833,53.139,202.806,53.139c84.974,0,154.514-4.884,202.795-53.139c48.294-48.254,53.205-117.714,53.205-202.613C311.992-28.472,307.028-97.995,258.626-146.231L258.626-146.231z"/>
                <path fill="#FFFFFF" d="M204.546-41.122c1.759,0,3.223,1.417,3.223,3.161v189.386c0,1.715-1.464,3.139-3.223,3.139H163.05c-1.781,0-3.228-1.424-3.228-3.139V-37.961c0-1.743,1.446-3.161,3.228-3.161H204.546z M24.468-41.122c31.303,0,64.033,1.435,80.176,17.59c16.143,16.154,17.656,47.549,17.656,78.286v96.671c0,1.715-1.446,3.139-3.219,3.139h-41.49c-1.777,0-3.229-1.424-3.229-3.139V53.09c-0.044-17.167-1.031-34.81-9.884-43.692c-7.62-7.641-21.839-9.391-36.625-9.754h-75.21c-1.764,0-3.208,1.419-3.208,3.136v148.645c0,1.715-1.462,3.139-3.237,3.139h-41.516c-1.774,0-3.201-1.424-3.201-3.139V-37.961c0-1.743,1.426-3.161,3.201-3.161H24.468z M33.755,34.305c1.766,0,3.201,1.413,3.201,3.143v113.977c0,1.715-1.436,3.139-3.201,3.139H-9.829c-1.792,0-3.228-1.424-3.228-3.139V37.448c0-1.73,1.436-3.143,3.228-3.143H33.755z"/>
              </g>
            </svg>
          </div>

          <!-- Texte central (positionné à 4% du haut) -->
          <div class="absolute left-0 right-0 text-center flex justify-center px-4" style="top: 4%;">
            <img
              v-if="bigTitleImage"
              :src="bigTitleImage"
              alt="Xiaomi présente REDMI Note 15 Series - Endurance titanesque"
              class="w-auto h-14 sm:h-24 md:h-32 lg:h-40 object-contain"
            />
          </div>

          <!-- Footer avec logos -->
          <div class="absolute bottom-2 left-2 right-2 sm:bottom-3 sm:left-3 sm:right-3 md:bottom-4 md:left-4 md:right-4 flex justify-between items-end">
            <!-- Logo HyperOS -->
            <div class="-ml-1 sm:-ml-2 md:-ml-3 -mb-2 sm:-mb-3 md:-mb-4">
              <img
                v-if="hyperImage"
                :src="hyperImage"
                alt="Powered by Xiaomi HyperOS"
                class="h-12 sm:h-16 md:h-20 lg:h-24 w-auto"
              />
            </div>

            <!-- Texte DAS -->
            <div class="text-[6px] sm:text-[8px] md:text-[10px] text-gray-500 text-right max-w-[120px] sm:max-w-xs hidden sm:block">
              <p>Image d'illustration. Le produit réel peut varier.</p>
              <p class="hidden md:block">DAS Redmi Note 15 Pro 5G : tête : 0.978 W/Kg, corps : 0.972 W/Kg, membres : 2.39 W/Kg.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section description -->
    <div class="w-full py-6 px-4 sm:px-8" style="background-color: #E8E4DF;">
      <div class="mx-auto text-center" style="max-width: 1240px;">
        <p class="text-gray-900 text-sm sm:text-base lg:text-lg leading-relaxed">
          <strong>L'offre de remboursement sera bientôt disponible.</strong><br>
          Revenez nous voir prochainement pour profiter de cette offre exceptionnelle.
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "WaitView",
  data() {
    return {
      bannerImage: null,
      bigTitleImage: null,
      hyperImage: null,
    };
  },
  created() {
    const images = [
      { key: 'bannerImage', file: 'home.png' },
      { key: 'bigTitleImage', file: 'bigtitle2.png' },
      { key: 'hyperImage', file: 'hyper.png' },
    ];
    images.forEach(({ key, file }) => {
      try {
        this[key] = require(`@/assets/images/${file}`);
      } catch (e) {
        this[key] = null;
      }
    });
  },
};
</script>
